<template>
    <div>
        <div class="popup_st03">
            <div :class="classPrefix + 'popup_wrap'">
                <div class="title">
                    <span class="ict_btn blue">{{ dongWaterInfo.val4 }}</span>
                    <span class="t01">상수도 현황</span>
                </div>
                <div class="text">
                    <span>{{ formatDate(dongWaterInfo.basdtVal) }} 기준</span>
                </div>

                <div class="pop_table02">
                    <table>
                        <caption>상수도리스트</caption>
                        <colgroup>
                            <col style="width: 45%;">
                            <col style="width: 55%;">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th class="left">
                                    pH
                                </th>
                                <td>{{ dongWaterInfo.val7 }} {{ waterHjdMeta['val7'].unit }}</td>
                            </tr>
                            <tr>
                                <th class="left">
                                    잔류염소
                                </th>
                                <td>{{ dongWaterInfo.val8 }} {{ waterHjdMeta['val8'].unit }}</td>
                            </tr>
                            <tr>
                                <th class="left">
                                    탁도
                                </th>
                                <td>{{ dongWaterInfo.val9 }} {{ waterHjdMeta['val9'].unit }}</td>
                            </tr>
                            <tr>
                                <th class="left">
                                    전기전도도
                                </th>
                                <td>{{ dongWaterInfo.val6 }} {{ waterHjdMeta['val6'].unit }}</td>
                            </tr>
                            <tr>
                                <th class="left">
                                    수온
                                </th>
                                <td>{{ dongWaterInfo.val10 }} {{ waterHjdMeta['val10'].unit }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="pop_bt_close2"><a href="javascript: void(0);" class="self-close-btn">닫기</a></div>
            </div>
        </div>
    </div>
</template>

<script>
import { $_TYPE } from '@/confs/common.const';
import {mapGetters} from "vuex";
import gripUtil from "@/libs/grip.util";
export default {
    props: {
        classPrefix: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dongWaterInfo: {},
        };
    },

    computed: {
        ...mapGetters({
            waterHjdMeta: 'getWaterHjdMeta',
        }),
    },

    updated() {
        if(typeof this.dongWaterInfo.val4 !== $_TYPE.UNDEF) {
            this.$emit('loaded-water-info', this.$el.innerHTML);
        }
    },

    methods: {
        setDongWaterInfo(dongWaterInfo) {
            this.dongWaterInfo = Object.assign({}, dongWaterInfo);
        },

        formatDate(val) {
            if(typeof val !== $_TYPE.UNDEF && val !== '') {
                return gripUtil.formatDate(val, 'yyyy-MM-dd');
            }
            return '';
        },
    },
}
</script>
